<script setup>
import { inject, ref, onMounted, watch, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import API from '@/js/api'

const dataset = inject('dataset')
const { t } = useI18n()
// const isLoading = ref(false)
const data = ref(null)
const model = ref({ cat: null, scat: null, type: null })

const toggleCategory = (category) => {
  if (model.value.cat) {
    model.value = { cat: null, scat: null, type: null }
  } else model.value.cat = category
}

const loadForm = () => {
  window.location.assign(form.value.url)
}

const form = computed(() => {
  return (
    model.value.cat?.form || model.value.scat?.form || model.value.type?.form
  )
})

onMounted(async () => {
  data.value = await API.get(dataset.api)
})
</script>

<template>
  <template v-if="data">
    <h2 class="is-size-4 mb-6" v-text="t('apply.category')" />

    <div class="columns is-mobile is-multiline has-fullheight-box mb-6">
      <template v-for="category in data.categories">
        <div
          class="column is-6-mobile is-4-tablet is-3-desktop"
          v-if="!model.cat || model.cat.id == category.id"
        >
          <a
            class="box is-award-category"
            :class="{ 'is-active': model.cat }"
            @click.prevent="toggleCategory(category)"
          >
            <div
              class="image is-hoverable is-small"
              v-html="category.logo + category.logo_hover"
            />

            <b-icon icon="x-circle" class="is-size-5" />
            <p class="is-size-8">{{ category.title }}</p>
          </a>
        </div>
      </template>
    </div>

    <div
      class="columns mb-7"
      v-if="model.cat && model.cat.subcategories.length"
    >
      <div class="column is-6">
        <b-field :label="t('apply.subcategory')" class="is-required">
          <b-dropdown
            v-model="model.scat"
            aria-role="list"
            expanded
            @change="model.type = null"
          >
            <template #trigger>
              <b-button
                :label="model.scat?.title || t('apply.select')"
                icon-right="caret-down-bold"
                size="is-large"
                class="is-size-6"
                expanded
              />
            </template>
            <b-dropdown-item
              v-for="subcat in model.cat.subcategories"
              :value="subcat"
            >
              {{ subcat.title }}
            </b-dropdown-item>
          </b-dropdown>
        </b-field>
      </div>
      <div
        class="column is-6"
        v-if="model.scat && model.scat.subsubcategories.length"
      >
        <b-field :label="t('apply.type')" class="is-required">
          <b-dropdown v-model="model.type" expanded>
            <template #trigger>
              <b-button
                :label="model.type?.title || t('apply.select')"
                icon-right="caret-down-bold"
                size="is-large"
                class="is-size-6"
                expanded
              />
            </template>
            <b-dropdown-item
              v-for="ctype in model.scat.subsubcategories"
              :value="ctype"
            >
              {{ ctype.title }}
            </b-dropdown-item>
          </b-dropdown>
        </b-field>
      </div>
    </div>

    <b-button
      :label="t('apply.submit')"
      :disabled="!form"
      :class="[form ? 'is-primary' : 'is-light']"
      class="is-medium is-wide is-size-6"
      rounded
      @click="loadForm"
    />
  </template>
</template>

<style lang="scss" scoped>
.box.is-award-category {
  text-align: center;
  position: relative;
  padding: 30px 30px 22px;

  .image {
    margin-bottom: 16px;

    :deep(svg) {
      max-width: 100%;
    }
  }

  .icon {
    top: 10px;
    right: 10px;
    position: absolute;
    display: none;
  }

  &.is-active {
    background: $primary;
    color: $primary-invert;

    .icon {
      display: inline-flex;
    }

    :deep(.image svg) {
      &:first-child {
        display: none;
      }

      &:last-child {
        display: inline-block;
      }
    }

    &:hover {
      .icon {
        transform: scale(1.2);
      }
    }
  }
}
</style>
